<template>
    <div class="schedule-wrapper">
        <div class="todomenu-wrapper">
            <to-do-menu
                :categories="categories"
                :viewType="viewType"
                :onConfirmDate="handleConfirmDate"
                :selectedDate="selectedDate"
                :onViewType="handleViewType"
                :onClickTitle="handleClickCategoryTitle"
                :onAddCategory="handleAddCategory"
                :onUpdateCategoryName="handleUpdateCategoryName"
                :onDeleteCategory="handleDeleteCategory"
            ></to-do-menu>
        </div>
        <div class="todolist-wrapper">
            <to-do-list
                :viewType="viewType"
                :todoDatas="todoAllData"
                :onDeleteTask="handleDeleteTask"
                :onSaveText="handleSaveText"
                :onAddTask="handleAddTask"
                :onMoveTask="handleMoveTask"
                :onShowEditContents="handleShowEditContents"
                :onToggleDone="handleToggleDone"
            ></to-do-list>
        </div>

        <iu-dialog
            class="contents-detail-wrapper"
            width="100%"
            top="5vh"
            style="height:100vh; overflow: hidden;"
            :visible.sync="showMarkdownDialog"
        >
            <markdown-setting
                :isChecked="detailData.isDone"
                :id="detailData.id"
                :title="detailData.title"
                :currentDate="detailData.currentDate"
                :createdDate="detailData.createdDate"
                :onToggleDone="handleToggleDone"
            ></markdown-setting>
            <markdown-panel :contents="detailData.contents" :onSave="handleContentsSave"></markdown-panel>
        </iu-dialog>
    </div>
</template>

<script>
import ToDoMenu from '@/components/ToDo/ToDoMenu';
import ToDoList from '@/components/ToDo/ToDoList';
import _ from 'lodash';
import firebasePlugin from '@/plugins/firebase';
import utils from '@/utils';

import MarkdownPanel from '@/components/MarkdownPanel';
import MarkdownSetting from '@/components/MarkdownSetting';

export default {
    components: {
        MarkdownPanel,
        MarkdownSetting,
        ToDoMenu,
        ToDoList,
    },
    data: function() {
        return {
            viewType: 'daily',
            isDragging: false,
            willRemoveFocusedTask: false,
            prevDailyDate: utils.date.getToday().format('YYYY-MM-DD'),
            selectedDate: utils.date.getToday().format('YYYY-MM-DD'),
            showMarkdownDialog: false,
            // dialog contents data
            detailData: {
                id: '',
                title: '',
                contents: '',
                currentDate: null,
                createdDate: null,
                isDone: false,
            },
        };
    },
    computed: {
        categories() {
            const categories = this.$store.state.todos.categories;
            return categories;
        },
        todoAllData() {
            let allTodos = this.$store.state.todos.todos;
            var keyList = [];

            // Handle key list
            if (this.viewType === 'daily') {
                keyList.push(parseInt(this.selectedDate.replace(/-/g, '')));
            } else if (this.viewType === 'weekly') {
                const dateRange = utils.date.getWeeklyDateRange(utils.date.parseFormatToDate(this.selectedDate));
                const dateRangeArray = utils.date.getArrayByDateRange(dateRange.startDate, dateRange.endDate);
                dateRangeArray.forEach(d => {
                    keyList.push(
                        parseInt(
                            d
                                .toISOString()
                                .substring(0, 10)
                                .replace(/-/g, '')
                        )
                    );
                });
            }
            let result = keyList.reduce((acc, cur) => {
                const tempTodos = allTodos
                    .filter(x => x.currentDateNumber.toString() === cur.toString())
                    .sort((a, b) => {
                        return a.order - b.order;
                    });
                acc.push([cur, tempTodos]);
                return acc;
            }, []);
            return result;
        },
        isToday() {
            return this.selectedDate === utils.date.getToday().format('YYYY-MM-DD');
        },
        isThisWeek() {
            const targetDate = utils.date.getMonday(utils.date.parseFormatToDate(this.selectedDate));
            const monday = utils.date.getMonday();
            return targetDate.isSame(monday, 'day');
        },
    },
    methods: {
        handleAddTask: function(date, title, callback) {
            const currentDateTodoList = this.todoAllData.find(x => x[0] === date) || null;
            const currentTodoList =
                !!currentDateTodoList && currentDateTodoList.length > 0
                    ? this.todoAllData.find(x => x[0] === date)[1]
                    : [];
            let order = 0;

            if (currentTodoList.length >= 30) {
                alert("Too many tasks already exist to finish in one day. \nReorganize your today's schedule!");
                return;
            }

            order = currentTodoList.length;

            firebasePlugin.todos.addTask(date, order, title, docRef => {
                this.$nextTick(function() {
                    if (typeof callback === 'function') {
                        callback(docRef.id);
                    }
                });
            });
        },
        handleSaveText(date, id) {
            const title = this.todoAllData.find(x => x[0] === date)[1].find(x => x.id === id).title;
            firebasePlugin.todos.setTaskTitle(id, title);
        },
        handleMoveTask(evt, date) {
            if (Object.prototype.hasOwnProperty.call(evt, 'moved')) {
                const oldIndex = evt.moved.oldIndex;
                const newIndex = evt.moved.newIndex;
                const startIndex = Math.min(oldIndex, newIndex);
                const endIndex = Math.max(oldIndex, newIndex);
                const ids = this.todoAllData
                    .find(x => x[0] === date)[1]
                    .sort((a, b) => a.order - b.order)
                    .map((x, idx) => (startIndex <= idx && idx <= endIndex ? x.id : null));

                const targetId = ids.splice(oldIndex, 1);
                ids.splice(newIndex, 0, ...targetId);

                firebasePlugin.todos.resetOrder(ids);
            } else if (Object.prototype.hasOwnProperty.call(evt, 'added')) {
                const ids = this.todoAllData.find(x => x[0] === date)[1].map(x => x.id);
                firebasePlugin.todos.setTaskCurrentDate(date, evt.added.element.id);
                firebasePlugin.todos.resetOrder(ids);
            } else if (Object.prototype.hasOwnProperty.call(evt, 'removed')) {
                // Nothing
            }
        },
        handleDeleteTask: _.throttle(function(date, id) {
            const allTodoByDate = this.todoAllData.find(x => x[0] === date);
            if (!allTodoByDate || !allTodoByDate.length) {
                return;
            }
            const todoById = allTodoByDate[1].find(x => x.id === id);
            const title = todoById.title || '';
            const contents = todoById.contents || '';

            // Show confirm if it doesn't have the
            const enableConfirmMsg = !title && !contents;
            if (enableConfirmMsg) {
                firebasePlugin.todos.deleteTask(date, id);
                this.$message({
                    type: 'success',
                    message: 'Delete completed',
                });
            } else {
                this.$confirm('Delete this task?', 'Warning', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                    type: 'warning',
                })
                    .then(() => {
                        firebasePlugin.todos.deleteTask(date, id);
                        this.$message({
                            type: 'success',
                            message: 'Delete completed',
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Delete canceled',
                        });
                    });
            }
        }, 200),
        handleToggleDone: _.throttle(function(id, isDone) {
            firebasePlugin.todos.toggleIsDone(id, isDone);
        }, 200),
        handleConfirmDate(date) {
            this.selectedDate = date;

            let startDate, endDate;

            if (this.viewType === 'daily') {
                startDate = this.selectedDate;
                endDate = this.selectedDate;
                this.prevDailyDate = this.selectedDate;
            } else if (this.viewType === 'weekly') {
                const dateRange = utils.date.getWeeklyDateRange(utils.date.parseFormatToDate(this.selectedDate));
                const dateRangeArray = utils.date.getArrayByDateRange(dateRange.startDate, dateRange.endDate);
                startDate = dateRangeArray[0].format('YYYY-MM-DD');
                endDate = dateRangeArray[dateRangeArray.length - 1].format('YYYY-MM-DD');
            }

            const payload = {
                startDate,
                endDate,
            };

            this.$store.commit('setDateRange', payload);
            firebasePlugin.todos.fetchTodos();
        },
        handleShowEditContents(date, id) {
            const targetTodo = this.todoAllData.find(x => x[0] === date)[1].find(x => x.id === id);

            if (!targetTodo) return;

            this.detailData = {
                id: id,
                title: targetTodo.title,
                contents: targetTodo.contents || '',
                currentDate: targetTodo.current_date.toDate(),
                createdDate: targetTodo.created_at.toDate(),
                isDone: targetTodo.isDone,
            };
            this.showMarkdownDialog = true;
        },
        handleContentsSave(contents) {
            // Save current contents for updating markdown data dynamically
            this.detailData.contents = contents;
            firebasePlugin.todos.setTaskContents(this.detailData.id, contents);
        },
        handleViewType(value) {
            this.viewType = value;

            if (value === 'weekly') {
                this.handleConfirmDate(this.selectedDate);

                this.$nextTick(function() {
                    if (this.viewType === 'weekly') {
                        const scrollElement = document.querySelector('.todolist > .ps');
                        if (scrollElement) {
                            const dayOfWeek = utils.date.getDayOFWeek(this.selectedDate);
                            scrollElement.scrollLeft = 420 * dayOfWeek;
                        }
                    }
                });
            }
        },
        handleClickCategoryTitle(categoryId) {
            this.$store.commit('setSelectedCategory', categoryId);
            firebasePlugin.todos.fetchTodos();
        },
        handleAddCategory(title) {
            firebasePlugin.todos.addCategory(title);
        },
        handleUpdateCategoryName(id, title) {
            firebasePlugin.todos.updateCategoryName(id, title);
        },
        handleDeleteCategory(id) {
            firebasePlugin.todos.deleteCategory(id);
        },
    },
};
</script>

<style lang="scss" scope>
.schedule-wrapper {
    display: flex;
    flex-direction: row;
    height: inherit;
    flex-wrap: nowrap;

    .todomenu-wrapper {
        overflow: overlay;
        height: inherit;
        flex-basis: 260px;
        background-color: #f1f1f1;
        border-right: 1px solid #ddd;
    }

    .todolist-wrapper {
        height: inherit;
        flex: 1;
        overflow: auto;
    }
}

.view-type {
    margin: 20px 0;
}

.daily-card-list {
    flex-direction: row;
    display: flex;
    height: 100%;

    .daily-card {
        width: 100%;
        padding: 10px;
    }
}
.list-group {
    height: 100%;
    min-height: 100px;

    .transition-group {
        min-height: 40px;
        display: inline-block;
        height: 100%;
        width: 100%;
    }
}

.draggable-wrapper {
    height: calc(100% - 100px);
    min-height: 200px;
}
.todolist {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;

    h1 {
        font-weight: bold;
        font-size: 2rem;
        margin: 20px auto;
    }

    h2 {
        font-weight: bold;
        font-size: 1.4rem;
        line-height: 3rem;
        height: 40px;
    }

    h3 {
        height: 26px;
        line-height: 20px;
        height: 22px;
        border-radius: 10px;
        margin: 10px auto;
    }
    h3.today {
        background-color: #1a73e8;
        color: #fff;
        width: fit-content;
        padding-left: 10px;
        padding-right: 10px;
    }

    .task {
        display: flex;
        align-items: center;
        min-width: 400px;
        max-width: 600px;
        height: 30px;
        margin: 5px auto;

        .handle {
            width: 30px;
            margin-right: 10px;
            cursor: move;
        }

        .text {
            width: 100%;

            input {
                border: none;
                background-color: transparent;
                color: #444;
                font-size: 1rem;
            }
        }

        .contents {
            width: 30px;
            cursor: pointer;
            margin-left: auto;
        }

        .trash {
            width: 30px;
            cursor: pointer;
            margin-left: auto;
        }

        i {
            opacity: 0;
            color: rgba(0, 0, 0, 0);
        }
        &.showSubButton {
            i {
                opacity: 1;
                color: #a7a7a7;
            }
        }

        &.done {
            input {
                text-decoration: line-through;
                color: #c8c8c8;
            }

            .iu-checkbox.is-checked {
                opacity: 0.5;
            }
        }
    }

    .add-new-task-btn {
        margin: 20px 0;
    }

    &.weekly {
        align-items: unset;

        .daily-card-list {
            .daily-card {
                border-right: 1px solid #ddd;
                min-width: 400px;
                width: auto;
                /* margin: 10px; */
                .draggable-wrapper {
                    .ps {
                        height: auto;
                        height: 100%;
                        max-height: 100%;
                        min-height: 62px;
                    }
                }
            }
        }
    }
    &.daily {
        .daily-card-list {
            .daily-card {
                /* border-right: 1px solid #d;
                min-width: 400px;dd */
                /* width: auto; */
                /* margin: 10px; */
                .draggable-wrapper {
                    .ps {
                        height: auto;
                        height: 100%;
                        max-height: 100%;
                        min-height: 62px;
                    }
                }
            }
        }
    }
}

.ps__rail-y {
    margin: 5px;
}

.flip-list-move {
    transition: transform 0.2s;
}
.no-move {
    transition: transform 0s;
}
.sortable-drag {
    opacity: 0;
}

.ghost {
    opacity: 0.6;
    background: #cef0ff;
}

.no-move {
    transition: transform 0s;
}

.contents-detail-wrapper {
    .iu-dialog {
        max-width: 1800px;

        .iu-dialog__body {
            padding: 0 20px 20px 20px;
        }
    }
}
</style>
